var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGuidelinesGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 0H5.625C2.5184 0 0 2.5184 0 5.625V18.375C0 21.4816 2.5184 24 5.625 24H18.375C21.4816 24 24 21.4816 24 18.375V5.625C24 2.5184 21.4816 0 18.375 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.90338 19.0349H6.88631V11.7905L2.625 8.5946V17.7565C2.625 18.4639 3.19819 19.0349 3.90338 19.0349Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 19.0349H20.0963C20.8037 19.0349 21.3747 18.4617 21.3747 17.7565V8.59448L17.1133 11.7905",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 6.25073V11.7905L21.3747 8.59457V6.88982C21.3747 5.30892 19.57 4.40761 18.3065 5.35579",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88672 11.7906V6.25092L12.0003 10.086L17.1139 6.25073V11.7905L12.0003 15.6258",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.625 6.88995V8.59451L6.88631 11.7905V6.25085L5.69316 5.35592C4.42753 4.40773 2.625 5.30904 2.625 6.88995Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelinesGmail);
export default __webpack_public_path__ + "static/media/guidelinesGmail.079b92622d2905e2652a05f480fc90f1.svg";
export { ForwardRef as ReactComponent };